module.exports = __webpack_public_path__ + "static/img/about_team_xxh.deef268.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/about/about_team_xxh.png
// module id = XvnK
// module chunks = 0